import { Grid, Icon, TableCell, TableRow, Typography } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Row = styled(TableRow)`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const Cell = styled(TableCell)`
  border: none;
  padding-bottom: 18px;
`;

function ClassPlanItem({ data, onClick }) {
  const textLimitHandler = text =>
    text && text.split(" ").length > 30
      ? `${text
          .split(" ")
          .slice(0, 30)
          .join(" ")}...`
      : text;

  return (
    <Row>
      <Cell>
        <Grid container alignItems="center" justify="center" spacing={1}>
          <Typography>
            {textLimitHandler(
              data.CONTEUDO || "Sem planejamento de conteúdo definido"
            )}
          </Typography>
        </Grid>
      </Cell>
      <Cell>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="center"
          spacing={1}
          style={{ cursor: "pointer" }}
          onClick={() => onClick(data)}
        >
          <Grid item>
            <Typography variant="body1" color="primary">
              {data.CONTEUDOEFETIVO !== ""
                ? "Ver detalhes"
                : "Marcar como feito"}
            </Typography>
          </Grid>
          <Grid item>
            <Icon color="primary">chevron_right</Icon>
          </Grid>
        </Grid>
      </Cell>
      <Cell>
        <Grid container alignItems="center" justify="center" spacing={1}>
          <Typography>
            {textLimitHandler(data.CONTEUDOEFETIVO) ||
              "Sem planejamento de conteúdo definido"}
          </Typography>
        </Grid>
      </Cell>
    </Row>
  );
}

ClassPlanItem.defaultProps = {
  onClick: () => {}
};

ClassPlanItem.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func
};

export default ClassPlanItem;
